import React from "react"
import PropTypes from "prop-types"
import Button from "@material-ui/core/Button"

import { withMutation } from "store/Mutation"

class FormCommitButton extends React.Component {
  static propTypes = {
    mutation: PropTypes.object,

    onSubmit: PropTypes.func,
  }

  _handleClick = e => {
    const { onSubmit, mutation } = this.props

    if (onSubmit) {
      e.preventDefault()

      // Allow any redux actions from input fields to fire before submitting
      setTimeout(() => onSubmit(mutation), 10)
    }
  }

  render() {
    const { mutation, ...otherProps } = this.props

    return (
      <Button
        type="submit"
        disabled={mutation.isSubmitting()}
        onClick={this._handleClick}
        {...otherProps}
      />
    )
  }
}

export default withMutation()(FormCommitButton)



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-Form/FormCommitButton.js